import { createApp } from 'vue'
import { createPinia } from 'pinia'
import VueSmoothScroll from 'vue3-smooth-scroll'
import './index.css'
import App from './App.vue'

//Constants
const pinia = createPinia()
const app = createApp(App)

//Use
app.use(pinia)
app.use(VueSmoothScroll)

//Mount
app.mount('#app')
